<template>
  <div class="login">
    <div class="title">
      <img src="@/assets/logo.png" alt="" width="200px">
    </div>
    <div class="login-info">
      <span>账号</span>
      <input type="text" placeholder="请输入账号" v-model="account" />
    </div>
    <div class="login-info">
      <span>密码</span>
      <input v-if="!showPaw" type="password" placeholder="请输入密码" v-model="password" />
      <img v-if="!showPaw" src="@/assets/logoInputBi.png" alt="" width="20px" @click="showPaw = true">

      <input v-if="showPaw" type="text" placeholder="请输入密码" v-model="password" />
      <img v-if="showPaw" src="@/assets/logoInput.png" alt="" width="20px" @click="showPaw = false">
    </div>
    <div class="login-btn" @click="getLogin">
      <div>登录</div>
    </div>
  </div>
</template>

<script>
import reqApi from "@/api/api.js";
export default {
  name: "UserLogin",
  components: {},
  data() {
    return {
      account: localStorage.getItem("userinfo")?.account || "",
      password: "",
      showPaw: false
    };
  },
  created() {
  },
  mounted() {

  },
  methods: {
    getLogin() {
      console.log(this.account, this.password);
      if (this.account == '' || this.password == '') {
        this.$message({
          message: "账号或密码不能为空",
          type: 'warning'
        });
        return
      }
      let params = {
        account: this.account,
        password: this.password,
      }
      reqApi.userLogin(params).then((res) => {
        if (res.data) {
          localStorage.setItem('token', res.data.userinfo.token);
          localStorage.setItem('userinfo', JSON.stringify(res.data.userinfo));
          this.$message({
            message: res.msg,
            type: 'success'
          });
          setTimeout(() => {
            this.$emit('getToken', res.data.userinfo.token);
          }, 1000)
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.login {
  width: 100%;
  height: 100vh;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: auto;
}

.title {
  margin-bottom: 100px;
}

.login-info {
  width: 60%;
  height: 50px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

}

.login-info span {
  width: 66px;
  height: 100%;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.login-info input {
  width: 50%;
  height: 100%;
  font-size: 16px;
  border: none;
  border-bottom: 1px solid #e5e5e5;
  outline: none;
}

.login-info img {
  margin-left: -20px;
}

.login-btn {
  width: 35%;
  height: 50px;
  background-color: #f19c9d;
  color: #fff;
  font-size: 18px;
  line-height: 50px;
  text-align: center;
  border-radius: 20px;
  margin-top: 50px;
}
</style>